import styled from 'styled-components';

import Divider from '@adsk/alloy-react-divider';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import UnstyledAnchor from '../../../UnstyledAnchor';

export const StyledBlockRemoveButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
`;

export const StyledPackagesEntityBlock = styled(UnstyledAnchor)`
  display: flex;
  height: 68px;
  padding: 12px 16px;
  overflow: hidden,
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  background-color: ${theme.colors.white};
  border-bottom: 1px solid ${theme.colors.charcoal100};

  &:hover ${StyledBlockRemoveButtonWrapper} {
    visibility: visible;
  }
`;

export const StyledPackagesEntityBlockContent = styled.div`
  overflow: hidden;
  flex-grow: 1;
`;

export const StyledPackageEntityBlockTitle = styled(OverflowTooltip).attrs({
  autoTipOnEllipsis: true,
  triggerTarget: OverflowTooltip.TRIGGER_TARGETS.TOOLTIP,
  getTargetProps: () => ({
    style: { fontSize: 14, fontWeight: 700 },
  }),
})``;

export const StyledPackagesEntityBlockDetail = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
`;

export const StyledPackagesEntityBlockDescription = styled(
  OverflowTooltip,
).attrs({
  autoTipOnEllipsis: true,
  triggerTarget: OverflowTooltip.TRIGGER_TARGETS.TOOLTIP,
  getTargetProps: () => ({
    style: { overflow: 'hidden' },
  }),
})``;

export const StyledDivider = styled(Divider).attrs({
  variant: Divider.VARIANTS.VERTICAL,
  height: 12,
  color: theme.colors.charcoal400,
})`
  margin: 0 12px;
`;

export const StyledPackageEntityBlockResourceCount = styled.div`
  white-space: nowrap;
`;
